import posthog from 'posthog-js';
import { track } from '@vercel/analytics';

// Check if we're in production environment
const shouldTrackAnalytics = () => {
  return import.meta.env.VITE_PUBLIC_APP_ENV === 'production';
};

// SHA-256 hashing function for user privacy
export const sha256 = async (message) => {
  const msgBuffer = new TextEncoder().encode(message);
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
};

export const trackUserIdentification = async (userId, userProperties = {}) => {
  if (!shouldTrackAnalytics()) {
    console.log('User identification skipped (non-production):', userId, userProperties);
    return;
  }

  try {
    // Hash the user ID for privacy
    const hashedUserId = await sha256(userId);

    // PostHog proper user identification
    if (typeof window !== 'undefined' && posthog) {
      posthog.identify(hashedUserId, {
        ...userProperties,
        identified_at: new Date().toISOString(),
      });
    }

    // Vercel Analytics user identification event
    if (typeof window !== 'undefined') {
      track('user_identified', {
        user_id: hashedUserId,
        ...userProperties,
        identified_at: new Date().toISOString(),
      });
    }
  } catch (error) {
    console.error('Error identifying user:', error);
  }
};

export const trackUserProperties = async (userId, properties) => {
  if (!shouldTrackAnalytics()) {
    console.log('User properties tracking skipped (non-production):', userId, properties);
    return;
  }

  try {
    const hashedUserId = await sha256(userId);
    
    if (typeof window !== 'undefined' && posthog) {
      posthog.people.set(properties);
    }

    // Track user properties update in Vercel Analytics
    if (typeof window !== 'undefined') {
      track('user_properties_updated', {
        user_id: hashedUserId,
        properties,
        updated_at: new Date().toISOString(),
      });
    }
  } catch (error) {
    console.error('Error setting user properties:', error);
  }
};

export const resetUserIdentification = () => {
  if (!shouldTrackAnalytics()) {
    console.log('User identification reset skipped (non-production)');
    return;
  }

  if (typeof window !== 'undefined' && posthog) {
    posthog.reset();
  }

  // Track user reset in Vercel Analytics
  if (typeof window !== 'undefined') {
    track('user_session_reset', {
      reset_at: new Date().toISOString(),
    });
  }
}; 